import { create } from "zustand";
import { API_URL } from "../Config/config";
import axiosInstance from "../services/axiosInstance";

const useProductStore = create((set, get) => ({
    isLoading: false,
    cartCount: 0,
    setCartCount: (count) => {
        set({ cartCount: count });
    },
    fetchProducts: async (body) => {
        try {
            const { limit, offset } = body;

            let URL = API_URL + "sku/dashboard-sku?limit=" + limit + "&offset=" + offset;

            if (body?.make_id) URL += "&make_id=" + body?.make_id;
            if (body?.segment_id) URL += "&segment_id=" + body?.segment_id;
            if (body?.size_id) URL += "&size_id=" + body?.size_id;
            if (body?.skuNameAndPartNoSearch) URL += "&skuNameAndPartNoSearch=" + body?.skuNameAndPartNoSearch;
            if (body?.order_id) URL += "&order_id=" + body?.order_id;
            if (body?.category_id) URL += "&category_id=" + body?.category_id;

            const result = await axiosInstance.get(URL);
            const response = result.data;

            if (response.code == 200) {
                return { status: true, data: response.data };
            } else {
                return { status: false, data: response.data };
            }
        } catch (err) {
            return { status: false, data: err.response };
        }
    },
    fetchPartNumber: async (body) => {
        try {
            let URL = API_URL + "sku/dashboard-sku-search-list";

            if (body?.part_no) URL += "?part_no=" + body?.part_no;
            if (body?.order_id) URL += "&order_id=" + body?.order_id;

            const result = await axiosInstance.get(URL);
            const response = result.data;
            // console.log(response);
            
            if (response.code == 200) {
                return { status: true, data: response.data?.resultSet };
            } else {
                return { status: false, data: response.data?.resultSet };
            }
        } catch (err) {
            return { status: false, data: err.response };
        }
    },

    fetchPartDetails : async () => {
        try {
            let URL = API_URL + "sku/getCodeGenareteSkuList";
            const result = await axiosInstance.get(URL);
            const response = result.data;

            if (response.code == 200) {
                return { status: true, data: response.data?.rows };
            }
        } catch (err) {
            return { status: false, data: err.response };
        }
    },

    createOrder: async (body) => {
        set({ isLoading: true });

        try {
            const result = await axiosInstance.post(
                API_URL + "order/create-order",
                body
            );
            const response = result.data;

            if (response.status == 201) {
                localStorage.removeItem("product_data");
                return { status: true, message: response.message };
            } else {
                return { status: false, message: response.message, data: [] };
            }
        } catch (err) {
            return { status: false, message: err.response.message || err?.message };
        } finally {
            set({ isLoading: false });
        }
    },
    fetchSkuMakeandSegment: async () => {
        try {
            const result = await axiosInstance.get(API_URL + "sku/master-sku-seg-make");
            const response = result.data;

            if (response.code == 200) {
                return { status: true, data: response.data };
            } else {
                return { status: false, message: response.message };
            }
        } catch (err) {
            return { status: false, message: err.message };
        }
    },
    downloadInventory: async (filter) => {
        try {
            const params = new URLSearchParams();

            if (filter?.make_id) params.append("make_id", filter.make_id);
            if (filter?.segment_id) params.append("segment_id", filter.segment_id);
            if (filter?.size_id) params.append("size_id", filter.size_id);
            if (filter?.category_id) params.append("category_id", filter.category_id);
            if (filter?.skuNameAndPartNoSearch) params.append("skuNameAndPartNoSearch", filter?.skuNameAndPartNoSearch);

            let URL = `${API_URL}sku/fore-cast-download?${params.toString()}`;

            const response = await axiosInstance.get(URL, {
                responseType: "blob",
              });
        
              if (response.headers["content-type"] !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                console.error("Unexpected response format:", await response.data.text());
                return { status: false, message: "Invalid response format" };
            }
            
            const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", "forecast.xlsx");
            document.body.appendChild(link);
            link.click();
    
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
    
            return { status: true };

        } catch (err) {
            return { status: false, data: err.response };
        }
    }
}));

export { useProductStore };